import { useContext } from "react";
import { BetContext } from "./BetContext";

const useBet = () => useContext(BetContext);

export default useBet;
